module.exports = __webpack_public_path__ + "public/SiteImages/dogdemo.png?2dc07e8b";